// Preload strategies for critical user flows
import { toast } from '@/hooks/use-toast';

const handlePreloadError = (err: unknown, modulePath: string) => {
  console.error(`Preload failed for: ${modulePath}`, err);
  // Show a single helpful message for preload failures
  toast({
    title: 'Background preload failed',
    description: 'Some resources failed to load. If pages don\'t open, hard refresh (Ctrl/Cmd+Shift+R).',
    variant: 'destructive',
  });
};

// Preload admin pages on hover
export const preloadAdminPages = () => {
  import('@/pages/admin/Users').catch((err) => handlePreloadError(err, '@/pages/admin/Users'));
  import('@/pages/admin/Cultivars').catch((err) => handlePreloadError(err, '@/pages/admin/Cultivars'));
  import('@/pages/admin/Hardware').catch((err) => handlePreloadError(err, '@/pages/admin/Hardware'));
};

// Preload marketplace components when entering marketplace
export const preloadMarketplace = () => {
  import('@/components/marketplace/MarketplaceCard').catch((err) => handlePreloadError(err, '@/components/marketplace/MarketplaceCard'));
  import('@/components/marketplace/ProductFilter').catch((err) => handlePreloadError(err, '@/components/marketplace/ProductFilter'));
  import('@/components/marketplace/ActiveFilterBar').catch((err) => handlePreloadError(err, '@/components/marketplace/ActiveFilterBar'));
};

// Preload formulation pages when entering formulations
export const preloadFormulations = () => {
  // No formulation pages to preload
};

// Preload heavy table components on demand
export const preloadTableComponents = () => {
  import('@/components/optimized/VirtualizedTable').catch((err) => handlePreloadError(err, '@/components/optimized/VirtualizedTable'));
  import('@/components/tables/ReusableTablePage').catch((err) => handlePreloadError(err, '@/components/tables/ReusableTablePage'));
};